
import { Vue, Component, Ref, Prop } from 'vue-property-decorator';
import { FormModel } from 'ant-design-vue';
import lazyInject from '@/di';
import RegionService from '@/services/region.service';
import SupplyService from '@/services/supply.service';
import { IResRegion } from '@/common/interface/region';

@Component
export default class EditTerminalReceiverModal extends Vue {
  visible = false;

  loading = false;

  distributor: any = null;

  @Ref('formRef')
  readonly formRef!: FormModel;

  @Prop()
  id?: string;

  regionOptions: IResRegion[] = [];

  // 级联选中项对应的名称数组 [province, city, district]
  selectedRegionNames: string[] = [];

  @lazyInject(RegionService)
  protected regionService!: RegionService;

  @lazyInject(SupplyService)
  supplyService!: SupplyService;

  form: any = {
    receiver: '',
    phone: '',
    address: '',
    regions: [] as number[],
    status: 1,
  };

  rules: any = {
    receiver: [{ required: true, message: '请输入收货人', trigger: 'blur' }],
    phone: [
      { required: true, message: '请输入联系电话', trigger: 'blur' },
      {
        pattern: /^1[3-9]\d{9}$/,
        message: '请输入正确的联系电话',
        trigger: 'blur',
      },
    ],
    regions: [{ required: true, message: '请选择省市区', trigger: 'change' }],
    address: [{ required: true, message: '请输入详细地址', trigger: 'blur' }],
    status: [{ required: true, message: '请选择状态', trigger: 'change' }],
  };

  open(distributor?: any) {
    this.distributor = distributor || null;
    this.visible = true;
    this.resetForm();
    this.getRegions();
    this.$nextTick(() => {
      this.formRef && this.formRef.clearValidate('');
    });
  }

  resetForm() {
    this.form = {
      receiver: '',
      phone: '',
      address: '',
      regions: [],
      status: 1,
    };
    this.selectedRegionNames = [];
  }

  async getRegions() {
    if (this.regionOptions.length) {
      return;
    }
    const res = await this.regionService.allRegions();
    if (res && res.length) {
      this.regionOptions = [...res];
    }
  }

  onRegionsChange(_value: any, selectedOptions: any[]) {
    this.selectedRegionNames = (selectedOptions || []).map(
      (opt: any) => opt && opt.name,
    );
  }

  handleOk() {
    this.formRef.validate(async (valid: boolean) => {
      if (!valid) return;
      const [provinceId, cityId, districtId] = this.form.regions || [];
      const [province, city, district] = this.selectedRegionNames;
      const params = {
        distributor_id: this.id,
        receiver: this.form.receiver,
        phone: this.form.phone,
        address: this.form.address,
        province: province || '',
        city: city || '',
        district: district || '',
        province_id: provinceId ? String(provinceId) : '',
        city_id: cityId ? String(cityId) : '',
        district_id: districtId ? String(districtId) : '',
        status: this.form.status,
      };
      this.loading = true;
      try {
        const res = await this.supplyService.postAddDelivery(params);
        if (res) {
          this.$message.success('添加成功');
          this.visible = false;
          this.$emit('refresh');
        }
      } finally {
        this.loading = false;
      }
    });
  }

  handleCancel() {
    this.visible = false;
    this.formRef && this.formRef.resetFields();
    this.resetForm();
  }
}
